import { render } from "./MyFloatingCard.vue?vue&type=template&id=2ef7a789&scoped=true&bindings={}"
import script from "./MyFloatingCard.vue?vue&type=script&lang=ts"
export * from "./MyFloatingCard.vue?vue&type=script&lang=ts"

import "./MyFloatingCard.vue?vue&type=style&index=0&id=2ef7a789&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ef7a789"

export default script